import { Injectable } from '@angular/core';
import { from, map, merge, Observable, of, take } from 'rxjs';
import { Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { App } from '@capacitor/app';
import versionData from '../../../app-version.json';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  readonly screenWidth$: Observable<number>;
  readonly platformReady$: Observable<string>;

  constructor(private readonly ionicPlatform: Platform) {
    this.platformReady$ = from(ionicPlatform.ready());

    this.screenWidth$ = merge(
      this.platformReady$.pipe(map(() => this.ionicPlatform.width())),
      this.ionicPlatform.resize.pipe(map(() => this.ionicPlatform.width()))
    );
  }

  isDebug(): boolean {
    return !environment.production;
  }

  isNativeMobile(): boolean {
    return this.ionicPlatform.platforms().includes('hybrid');
  }

  isWeb(): boolean {
    return !this.ionicPlatform.platforms().includes('hybrid');
  }

  getAppVersion(): Observable<string> {
    // if (this.isWeb()) {
    //   return of('Web');
    // }
    // return (this.isWeb() ? of(versionData) : from(App.getInfo())).pipe(
    return of(versionData).pipe(
      take(1),
      map((info) => `${info.version} (${info.build})`)
    );
  }
}
